import React from 'react';
const RegisterIcon: React.FC<{size?: number; color?: string}> = ({ size = 18, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="7" r="3" stroke={color} strokeWidth="1.8" />
    <path d="M3 16C3 13.8 5.2 12 8 12C10.8 12 13 13.8 13 16" stroke={color} strokeWidth="1.8" strokeLinecap="round" />
    <path d="M15 7V13" stroke={color} strokeWidth="1.8" strokeLinecap="round" />
    <path d="M12 10H18" stroke={color} strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);
export default RegisterIcon;

